module.exports = __webpack_public_path__ + "static/media/forklift.83c749f8.svg";